var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-2 mx-1"},[_c('div',{staticClass:"route col-6 text-center",style:({ opacity: _vm.isDowntime ? '1' : '0.5' })}),_c('LinePauseButton',{staticClass:"route col-6 text-center",attrs:{"line-id":_vm.elementId,"is-forced":_vm.currentState ? _vm.currentState.isForced : false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }